import { Check } from "lucide-react";

export const PdfPicker = ({ images, cover, grid, onChange }) => {
  if (!images.length) return null;
  const coverSrc = cover || images[0];

  const toggleGrid = (src) => {
    if (grid.includes(src)) onChange({ cover, grid: grid.filter((g) => g !== src) });
    else if (grid.length < 4) onChange({ cover, grid: [...grid, src] });
  };

  return (
    <div data-testid="pdf-picker">
      <p className="font-mono text-[11px] uppercase tracking-[0.2em]">Foto per il PDF</p>
      <p className="mt-1 text-xs text-[#1c1418]/70">
        Tocca una foto per metterla nella composite (max 4, in ordine). Usa «Copertina» per scegliere la prima pagina.
        Se non scegli nulla: copertina = prima foto, composite = le 4 successive.
      </p>
      <div className="mt-3 grid grid-cols-4 gap-2 sm:grid-cols-6">
        {images.map((src, i) => {
          const pos = grid.indexOf(src);
          const isCover = src === coverSrc;
          return (
            <div key={src + i} className="relative">
              <button type="button" onClick={() => toggleGrid(src)} data-testid={`pdf-grid-toggle-${i}`}
                className={`block aspect-[2/3] w-full overflow-hidden border-2 ${pos >= 0 ? "border-[#1c1418]" : "border-transparent"}`}>
                <img src={src} alt="" loading="lazy" className={`h-full w-full object-cover ${pos >= 0 || isCover ? "" : "opacity-60"}`} />
              </button>
              {pos >= 0 && (
                <span className="absolute right-1 top-1 grid h-6 w-6 place-items-center rounded-full bg-[#1c1418] font-mono text-[11px] text-white">{pos + 1}</span>
              )}
              <button type="button" onClick={() => onChange({ cover: src, grid })} data-testid={`pdf-cover-set-${i}`}
                className={`mt-1 flex w-full items-center justify-center gap-1 py-1 font-mono text-[10px] uppercase tracking-[0.1em] ${isCover ? "bg-[#1c1418] text-white" : "border border-[#1c1418]/30"}`}>
                {isCover && <Check className="h-3 w-3 text-[#e9458f]" />} Copertina
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
